module.exports = __webpack_public_path__ + "img/login_tab04_04.e7736eb1.png";